module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- 日历 -->\r\n<section class="calendar-wrap" onselectstart="return false;">\r\n    <div class="calendar-head-bg no-track-click" data-track="公共_日历_拖拽"></div>\r\n\r\n    <div class="month-switch-bar-wrap">\r\n        <div class="month-switch-bar month-left hidden" data-track="公共_日历_月份_上一月"></div>\r\n        <div class="month-switch-bar month-right" data-track="公共_日历_月份_下一月"></div>\r\n    </div>\r\n\r\n    <!-- 各月份的字符串 -->\r\n    ' +
((__t = ( monthStr )) == null ? '' : __t) +
'\r\n</section>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/myCalendar/templates/calendarPanel.ejs
// module id = 38
// module chunks = 1 2 3 4 5 6 7 8 9 19 25